module.exports = __webpack_public_path__ + "media/assets/icons/tickets-2dc1935f8a24d3538e4ab8c2ce05e9bf.svg";